import { BsDash } from 'react-icons/bs';
import { FiPhoneCall } from 'react-icons/fi';
import { IoMailOutline } from 'react-icons/io5';
import { useState } from 'react';
import Fade from 'react-reveal/Fade';

const ContactPage = () => {

    const subject = "MESSAGE FROM (PORTFOLIO)"
    const [message, setMessage] = useState("");
    const [name, setName] = useState("");

    return (
        <div className="h-full w-full px-[30px] bg-primary flex flex-col lg:flex-row gap-[100px] lg:gap-[30px] py-[150px]">
            <div className="lg:basis-[55%] h-[600px] flex flex-col gap-[15px]">
                <p className='flex text-accent items-center text-[16px] font-poppins'><BsDash />  Contact Me</p>
                <h1 className='text-[38px] font-[600] font-montserrat text-white'>Get In Touch With Me</h1>
                <Fade bottom>
                    <p className='text:[14px] lg:text-[18px] font-poppins font-[360] text-ash leading-[26px]'>The technological revolution is changing aspect of our lives, and the fabric of society itself. it's also changing the way we learn and what we learn. Factual knowledge is less prized when everything you ever need to know can be found on your phone. There's no imperative to be an expert Factual knowledge is less prized when everything you ever need to know can be found at doing everything.</p>
                </Fade>
                <div className='flex flex-col md:flex-row lg:flex-col gap-[30px] mt-4'>
                    <Fade right>
                        <div className='contact'>
                            <div className=''><FiPhoneCall /></div>
                            <div>
                                <h1 className=''>Phone</h1>
                                <p className=''>+234 905 5220 828</p>
                                <p className=''>+234 903 9226 577</p>
                            </div>
                        </div>
                    </Fade>
                    <Fade right>
                        <div className='contact lg:ml-[70px]'>
                            <div className=''><IoMailOutline /></div>
                            <div>
                                <h1 className=''>Email</h1>
                                <p className=' break-all'>mazeedahhamzat@gmail.com</p>
                            </div>
                        </div>
                    </Fade>
                </div>
            </div>
            <Fade bottom>
                <div className="lg:basis-[45%] flex gap-[30px] flex-col pt-[100px] md:pt-0">
                    <div className='flex flex-col md:flex-row gap-[30px]'>
                        <input type="text" className='special-input' value={name} onChange={(e) => { setName(e.target.value) }} placeholder='Full Name' />
                        <input type="text" className='special-input' placeholder='Email' />
                    </div>
                    <textarea value={message} onChange={(e) => { setMessage(e.target.value) }} name="message" id="message" className='special-textarea' placeholder='Message *' ></textarea>
                    <a href={`mailto: mazeedahhamzat@gmail.com?subject=MESSAGE FROM ${name.toUpperCase()}(PORTFOLIO)&body=${message}`} className="w-[190px] h-[60px] flex justify-center items-center mt-6 text-primary rounded-[14px] font-montserrat text-[16px] font-[500] cursor-pointer bg-[transparent] bg-gradient-to-r from-secondary to-text  hover:bg-gradient-to-l transition-all duration-[1000ms] whitespace-nowrap shadow-md shadow-text hover:shadow-none"
                    >Send To Me</a>
                </div>
            </Fade>
        </div>
    );
}

export default ContactPage;